// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__D4MUf","toggle":"style_toggle__QOVVe","toggle_btn":"style_toggle_btn__faaBB"};